import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=0f6fc0b1&scoped=true"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=0f6fc0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6fc0b1",
  null
  
)

export default component.exports